import { environment } from "../config/environment";

const amplifyConfig = {
  aws_project_region: environment.cognitoRegion,
  aws_cognito_region: environment.cognitoRegion,
  aws_user_pools_id: environment.cognitoUserPoolId,
  aws_user_pools_web_client_id: environment.cognitoAppClientId,
};

export default amplifyConfig;
